import { useSyncExternalStore } from 'react';
import { noop, constant } from 'lodash-es';
import { useIsFramed } from 'site-modules/shared/hooks/use-is-framed';
import { logger } from 'client/utils/logger/logger';
import { CANVAS_PATHNAME } from 'site-modules/shared/constants/co-driver/url';

export function useCoDriverScope() {
  const isIFrameScope = useIsFramed();

  return useSyncExternalStore(
    noop,
    () => {
      let isInCanvas = false;

      try {
        const { pathname } = window.parent.location;
        isInCanvas = pathname.startsWith(CANVAS_PATHNAME);
      } catch (error) {
        logger.warn('App renders in cross-origin iframe. Error accessing window.parent.location:', error);
      }

      return isIFrameScope && isInCanvas;
    },
    constant(false)
  );
}
